import React from 'react';

const SvgAllSpecies = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 36 36"
    {...props}
  >
    <path
      fill="currentColor"
      fillOpacity={0.85}
      d="M7.428 9.063a1.152 1.152 0 1 0 0-2.304 1.152 1.152 0 0 0 0 2.304Zm2.719 8.753a1.152 1.152 0 1 0 0-2.304 1.152 1.152 0 0 0 0 2.304Z"
    />
    <path
      fill="currentColor"
      fillOpacity={0.85}
      d="m34.15 26.759 1.434-4.304a2.765 2.765 0 0 0-3.795-3.377l-.358-1.073 1.434-4.304a2.765 2.765 0 0 0-3.795-3.377l-.358-1.073 1.434-4.304a2.765 2.765 0 0 0-4.16-3.171l-3.101 2.075c-2.883-1.793-6.52-2.829-10.104-2.829-2.312 0-4.502.442-6.332 1.278C2.442 4.134.712 7.699.528 8.1a2.763 2.763 0 0 0 .002 2.314c.149.322 1.316 2.696 3.868 4.561-.706.95-1.072 1.706-1.151 1.878a2.763 2.763 0 0 0 .002 2.314c.149.322 1.316 2.696 3.868 4.561-.706.95-1.072 1.706-1.151 1.878a2.763 2.763 0 0 0 .002 2.314c.184.399 1.915 3.948 5.92 5.777 1.831.836 4.02 1.278 6.332 1.278 3.583 0 7.221-1.035 10.104-2.829l3.101 2.075a2.76 2.76 0 0 0 3.214-.1 2.764 2.764 0 0 0 .945-3.073l-1.433-4.289h-.001ZM3.039 9.255s1.37-2.981 4.559-4.437c1.525-.697 3.321-1.028 5.184-1.028 3.575 0 7.4 1.22 10.053 3.424l4.688-3.137-1.725 5.178.88 2.634-1.074.718c-2.883-1.793-6.52-2.829-10.104-2.829-2.312 0-4.502.442-6.332 1.278a11.861 11.861 0 0 0-2.882 1.875c-2.254-1.537-3.248-3.676-3.248-3.676h.001Zm2.719 8.753s1.37-2.981 4.559-4.437c1.525-.697 3.321-1.028 5.184-1.028 3.575 0 7.4 1.22 10.053 3.424l4.688-3.137-1.725 5.178.88 2.634-1.074.718c-2.883-1.793-6.52-2.829-10.104-2.829-2.312 0-4.502.442-6.332 1.278a11.861 11.861 0 0 0-2.882 1.875c-2.254-1.537-3.248-3.676-3.248-3.676h.001Zm27.203 13.917-4.688-3.137c-2.653 2.203-6.479 3.424-10.053 3.424-1.863 0-3.658-.332-5.184-1.028-3.189-1.457-4.559-4.422-4.559-4.422s1.37-2.981 4.559-4.437c1.525-.697 3.321-1.028 5.184-1.028 3.575 0 7.4 1.22 10.053 3.424l4.688-3.137-1.725 5.178 1.725 5.164v-.001Z"
    />
    <path
      fill="currentColor"
      fillOpacity={0.85}
      d="M12.866 26.569a1.152 1.152 0 1 0 0-2.304 1.152 1.152 0 0 0 0 2.304Z"
    />
  </svg>
);
export default SvgAllSpecies;
